import React from "react";


export class ResultsFilters extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const sections = Object.keys(this.props.sections).map((section) => {
            return {
                titleFull: this.props.sections[section].title,
                value: this.props.sections[section].id,
                title: this.props.sections[section].title_short
            };
        });
        const laps = Object.keys(this.props.laps).map((lap) => {
            return {
                titleFull: this.props.laps[lap].title,
                value: this.props.laps[lap].idkey,
                title: this.props.laps[lap].title_short ? this.props.laps[lap].title_short : this.props.laps[lap].nr
            };
        });
        const classes = Object.keys(this.props.eventClasses).map((eventClass) => {
            return {
                titleFull: this.props.eventClasses[eventClass].title,
                value: this.props.eventClasses[eventClass].id,
                title: this.props.eventClasses[eventClass].title
            };
        });

        const competitions = Object.keys(this.props.competitions).map((key) => {
            return {
                titleFull: this.props.competitions[key].title,
                value: this.props.competitions[key].id,
                title: this.props.competitions[key].title
            };
        });
        var mobileFilterClass = "";
        if (!this.props.isMobileFilterVisible) {
            mobileFilterClass += " hidden";
        }

        const competitionsFilter = competitions && competitions.length > 0
            ? <ResultsFilter title="Įskaitos:"
                             allValuesText={null}
                             values={competitions}
                             selectedValue={this.props.filter_competition}
                             onFilterValueSelected={this.props.onFilterCompetitionSelected}/>
            : null;


        return ([
            <div id="desktop-filters" key="desktop-filters">
                {
                    Object.keys(sections).length > 1
                        ? <ResultsFilter title="Sekcijos:"
                                         allValuesText={null}
                                         values={sections}
                                         selectedValue={this.props.filter_section}
                                         onFilterValueSelected={this.props.onFilterSectionSelected}
                        /> : null
                }
                {
                    this.props.showLapsFilter ?
                    <ResultsFilter title="Važiavimai:"
                                   allValuesText={this.props.filter_laps_allvalues_disabled ? null : "Visi"}
                                   values={laps}
                                   selectedValue={this.props.filter_laps}
                                   onFilterValueSelected={this.props.onFilterLapSelected}
                    /> : null
                }
                <ResultsFilter title="Klasės:"
                               allValuesText="Visos"
                               values={classes}
                               selectedValue={this.props.filter_eventClass}
                               onFilterValueSelected={this.props.onFilterClassSelected}
                />
                {competitionsFilter}

            </div>,

            <div id="mobile-filters" className={mobileFilterClass} key="mobile-filters">
                <div className="nav-container">
                    <nav className="navbar navbar-expand mb-4 navbar-custom container">
                        <div className="back-button" onClick={() => this.props.onBackPressed() }/>
                        <h5>Filtravimas</h5>
                    </nav>


                </div>

                {
                    Object.keys(sections).length > 1
                        ? <ResultsFilter title="Sekcijos:"
                               allValuesText="Visi"
                               values={sections}
                               selectedValue={this.props.filter_section}
                               onFilterValueSelected={this.props.onFilterSectionSelected}
                    /> : null
                }
                {
                    this.props.showLapsFilter
                        ? <ResultsFilter title="Važiavimai:"
                                   allValuesText={this.props.filter_laps_allvalues_disabled ? null : "Visi"}
                                   values={laps}
                                   selectedValue={this.props.filter_laps}
                                   onFilterValueSelected={this.props.onFilterLapSelected}
                        /> : null
                }
                <ResultsFilter title="Klasės:"
                               allValuesText="Visos"
                               values={classes}
                               selectedValue={this.props.filter_eventClass}
                               onFilterValueSelected={this.props.onFilterClassSelected}
                />
                {competitionsFilter}
            </div>
        ]);
    }
}


export class ResultsFilter extends React.Component {
    render() {
        let elements = this.props.values.map(value => {
            const isActive = value.value === this.props.selectedValue;
            return <ResultsFilterValue key={value.value}
                                       title={value.title}
                                       titleFull={value.titleFull}
                                       isActive={isActive}
                                       onClick={() => this.props.onFilterValueSelected(value.value)}/>
        });
        let allValuesElement = this.props.allValuesText
            ? <ResultsFilterValue key={null}
                                  title={this.props.allValuesText}
                                  isActive={this.props.selectedValue === null}
                                  onClick={() => this.props.onFilterValueSelected(null)} />
            : null;

        return (
            <div className="results-filter">
                <h5>{this.props.title}</h5>
                <ol className="filter-values">
                    {allValuesElement}
                    {elements}
                </ol>
            </div>
        );
    }
}

class ResultsFilterValue extends React.Component {
    render() {
        const fullTitle = this.props.titleFull ? this.props.titleFull : this.props.title;
        var classes = "results-value";
        if (this.props.isActive) {
            classes += " active";
        }
        return (
            <li className={classes} title={fullTitle} onClick={() => this.props.onClick()}>
                {this.props.title}
            </li>
        );
    }
}
